import { api } from '../../base';
import { getToolsPrefix } from '../../common';
import {
    IDeleteUserMailboxAction,
    IPostConnectUserGmailAction,
    IPostConnectUserOutlookAction,
} from '../user/redux/interface';

export const fetchMyUser = () => {
    return api.get({ url: `${getToolsPrefix()}users/myuser/` });
};

export const fetchCompanyBaseUsers = () => {
    return api.get({ url: 'users/get_base_company_users/' });
};

export const postConnectUserGmail = (payload: IPostConnectUserGmailAction) => {
    return api.post({
        url: 'connectusergmailcallback/',
        data: payload,
    });
};

export const postConnectUserOutlook = (
    payload: IPostConnectUserOutlookAction
) => {
    return api.post({
        url: 'connectuseroutlookcallback/',
        data: {
            code: payload.code,
            codeVerifier: payload.codeVerifier,
            redirectPath: payload.redirectPath,
        },
    });
};

export const deleteUserMailbox = (payload: IDeleteUserMailboxAction) => {
    return api.delete({
        url: `user-mailboxes/${payload.id}/`,
    });
};
